import { render } from "./QuarterlyReviewPacket.vue?vue&type=template&id=19682052&scoped=true"
import script from "./QuarterlyReviewPacket.vue?vue&type=script&lang=js"
export * from "./QuarterlyReviewPacket.vue?vue&type=script&lang=js"

import "./QuarterlyReviewPacket.vue?vue&type=style&index=0&id=19682052&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19682052"]])

export default __exports__